module.exports = __webpack_public_path__ + "static/media/thumb_flappyBird.cce7e6e7.jpg";